export default __webpack_public_path__ + "static/media/header_community_desexing.433d466c.png";